import { useEffect } from "react";

interface UseCloseOnEscapeParams {
  isOpen: boolean;
  onClose: () => void;
  stopPropagation?: boolean;
  preventDefault?: boolean;
}

/**
 * Triggers onClose when Escape is pressed while isOpen is true.
 */
export const useCloseOnEscape = (params: UseCloseOnEscapeParams): void => {
  const isOpen = params.isOpen;
  const onClose = params.onClose;
  const stopPropagation = params.stopPropagation ?? false;
  const preventDefault = params.preventDefault ?? false;

  useEffect(() => {
    if (!isOpen) return;

    const handleKeyDown = (event: KeyboardEvent): void => {
      if (event.key !== "Escape") return;
      if (stopPropagation) event.stopPropagation();
      if (preventDefault) event.preventDefault();
      onClose();
    };

    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [isOpen, onClose, stopPropagation, preventDefault]);
};
